import { getAbsoluteAssetSize } from 'helpers/getAbsoluteAssetSize'
import { ImageAsset, TextAsset } from '~/models/Asset'
import { addToBox } from '~/features/konva-shapes/addToBox'
import { createImage } from '~/features/konva-shapes/createImage'
import { createText } from '~/features/konva-shapes/createText'
import { getImageWithChromakeyUrl } from '../../../components/Preview/useImageChromaKey'

export const createKonvaShape = (asset, refAsset, { scale, boundingRect }) => {
  if (asset instanceof ImageAsset) {
    return Promise.resolve()
      .then(() => asset.settings.isChromaKeyEnabled ? getImageWithChromakeyUrl(asset) : asset.url)
      .then(url => createImage(
        url,
        { ...asset.settings, size: getAbsoluteAssetSize(asset, refAsset) },
        undefined,
        { scale, forRender: true }
      ))
      .then(img => addToBox(img, asset.settings))
  }

  if (asset instanceof TextAsset) {
    return Promise.resolve(createText(asset, { boundingRect, scale }))
  }

  return Promise.resolve()
}
